/* eslint-disable max-len */
import { template_translation } from '../../lang/TemplateTranslation';
const t = template_translation;

/* 1.基本 */
export const template1 = {
  title: t.to('繰り返しブロック', 'title_nttd01'),
  desc: t.to(
    '繰り返しブロックを使うと同じブロックをたくさん作り出すことができます。',
    'desc_nttd01'
  ),
  img: '../template/4.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" id="By8o*,w-)Y1;b[:]VN%f" x="250" y="70">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="a-camera_v2.1" id="Lwk-BiVf1l|(e!3svl__">
        <field name="position-x">0</field>
        <field name="position-y">1.7</field>
        <field name="position-z">0</field>
        <field name="avator_type">teat_Avatar_ver2.glb</field>
        <field name="click_type">cursor</field>
        <value name="ATTR">
          <block type="ahead" id="^+]a=-ZX(NGJ{s3jWo.b">
            <field name="speed">0.1</field>
            <field name="pitchSwitch">false</field>
            <field name="stopattouch">false</field>
          </block>
        </value>
        <next>
          <block type="logic_range-loop_v2" id="O2awbbzvz!?l0.!0ZzQ5">
            <field name="COUNTER_VAR">x</field>
            <field name="RANGE_MIN">0</field>
            <field name="RANGE_MAX">200</field>
            <statement name="IN">
              <block type="sphere_v2" id="dygET;aYQ+YNoE+XrT!g">
                <field name="id">block</field>
                <field name="position-x">0</field>
                <field name="position-y">0</field>
                <field name="position-z">-4</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2" id="A+]kg6e?qGzkM4n9;!ak">
                    <field name="COLOUR">#fff600</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="random-position" id=")N:YqJ}]yef=b8w)z!so">
                    <value name="ATTR">
                      <block type="scale_v2" id="QJmDw6q[$%_xZ0%?$A46">
                        <field name="scale-x">0.1</field>
                        <field name="scale-y">0.1</field>
                        <field name="scale-z">0.1</field>
                      </block>
                    </value>
                  </block>
                </value>
              </block>
            </statement>
            <next>
              <block type="a-sky" id="%EI!omxP]lWXPb9LbJw^">
                <value name="COLOUR">
                  <shadow type="color_value_v2" id="bsJ[ygR-A@6(Aad9%6g#">
                    <field name="COLOUR">#0a1d68</field>
                  </shadow>
                </value>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>`,
  js_code: `const rig = document.getElementById("rig")
window.addEventListener("keypress",(e)=>{
    if(e.key === "q") rig.object3D.rotation.y += 0.1
    if(e.key === "e") rig.object3D.rotation.y -= 0.1
})
`,
};
